module.exports = __webpack_public_path__ + "img/portrait-2048.0e5870af.png";